import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextareaDrag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTextareaDrag"><Path d="M14.75 21.25L21.25 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M6.75 21.25L21.25 6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconTextareaDrag;
